import { z } from 'zod';
import { MANAGEMENT_FEE_SWEEP_PROPERTY_STATUSES } from './managementFees';

const managementFeeSweepLiquidityProjectionSchema = z.object({
  spendableCents: z.number(),
  rawBalanceCents: z.number(),
  reserveCents: z.number(),
  isReserveViolation: z.boolean(),
  isLikelyPayable: z.boolean(),
});

const managementFeeSweepPropertyRowSchema = z.object({
  propertyId: z.string(),
  propertyName: z.string(),
  policyLabel: z.string(),
  basisKind: z.enum(['COLLECTED', 'BILLED', 'FLAT_MONTHLY']).nullable(),
  basisCents: z.number().nullable(),
  feeCents: z.number(),
  status: z.enum(MANAGEMENT_FEE_SWEEP_PROPERTY_STATUSES),
  billId: z.string().optional(),
  invoiceNumber: z.string().optional(),
  detail: z.string().optional(),
  liquidityProjection: managementFeeSweepLiquidityProjectionSchema.optional(),
});

/** POST /accounting/management-fee-sweeps response (dry-run or commit). */
export const managementFeeSweepReportSchema = z.object({
  operatingOrganizationId: z.string(),
  accrualPeriodYyyyMm: z.string(),
  dryRun: z.boolean(),
  periodInclusiveStart: z.string(),
  periodInclusiveEnd: z.string(),
  propertyCount: z.number(),
  rows: z.array(managementFeeSweepPropertyRowSchema),
  summary: z.object({
    successPosted: z.number(),
    successIdempotent: z.number(),
    skippedNoFeePolicy: z.number(),
    skippedZeroFee: z.number(),
    skippedDryRun: z.number(),
    errors: z.number(),
  }),
});
